// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file entity/contact_read_status.proto (package entity, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * ContactReadStatus構造体
 *
 * @generated from message entity.ContactReadStatus
 */
export class ContactReadStatus extends Message<ContactReadStatus> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string admin_user_id = 2 [json_name = "admin_user_id"];
   */
  adminUserId = "";

  /**
   * @generated from field: string contact_id = 3 [json_name = "contact_id"];
   */
  contactId = "";

  /**
   * @generated from field: bool is_read = 4 [json_name = "is_read"];
   */
  isRead = false;

  /**
   * @generated from field: google.protobuf.Timestamp read_at = 5 [json_name = "read_at"];
   */
  readAt?: Timestamp;

  /**
   * @generated from field: string environment = 6;
   */
  environment = "";

  /**
   * @generated from field: google.protobuf.Timestamp create_date = 7 [json_name = "create_date"];
   */
  createDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_date = 8 [json_name = "update_date"];
   */
  updateDate?: Timestamp;

  /**
   * @generated from field: string version = 9;
   */
  version = "";

  constructor(data?: PartialMessage<ContactReadStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.ContactReadStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "admin_user_id", jsonName: "admin_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "contact_id", jsonName: "contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_read", jsonName: "is_read", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "read_at", jsonName: "read_at", kind: "message", T: Timestamp },
    { no: 6, name: "environment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "create_date", jsonName: "create_date", kind: "message", T: Timestamp },
    { no: 8, name: "update_date", jsonName: "update_date", kind: "message", T: Timestamp },
    { no: 9, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ContactReadStatus {
    return new ContactReadStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ContactReadStatus {
    return new ContactReadStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ContactReadStatus {
    return new ContactReadStatus().fromJsonString(jsonString, options);
  }

  static equals(a: ContactReadStatus | PlainMessage<ContactReadStatus> | undefined, b: ContactReadStatus | PlainMessage<ContactReadStatus> | undefined): boolean {
    return proto3.util.equals(ContactReadStatus, a, b);
  }
}

